/* angular:styles/component:css;69f942643ec389bfd9175e1b1f4baf12a9f9455526216bbb0e31484ae2b0ae7e;/home/vsts/work/1/s/projects/fitnessforservice/src/app/help/help.component.ts */
.help_dialog_close_btn {
  background: #0B2D71;
  color: #FFFFFF;
  margin: 8px 7px 0 0;
}
/*# sourceMappingURL=help.component-X3N5WPXE.css.map */
